//current
import React, { useState } from 'react';

const PrintButton = ({ targetId, buttonLabel = "Print", buttonClass = "print-button" }) => {
    const [isPreparingPrint, setIsPreparingPrint] = useState(false);

    const handlePrint = () => {
    setIsPreparingPrint(true);
    
    const content = document.getElementById(targetId);
    if (!content) {
        console.error('Print target not found:', targetId);
        setIsPreparingPrint(false);
        return;
    }

    // IMPROVED: Get all form data including better requisition ID detection
    const getAllFormData = () => {
        const data = {};
        
        console.log('=== DEBUG: STARTING FORM DATA EXTRACTION ===');
        
        // Get values from all inputs, selects, and textareas
        const formElements = content.querySelectorAll('input, select, textarea');
        console.log(`Found ${formElements.length} form elements`);
        
        formElements.forEach(element => {
            const elementName = element.name || element.id || '';
            const elementValue = element.value || '';
            
            if (elementName && elementValue) {
                data[elementName] = elementValue;
                console.log(`Form element: ${elementName} = ${elementValue}`);
            }
        });

        // Get values from visible fields by their labels
        const labels = content.querySelectorAll('label');
        console.log(`Found ${labels.length} labels`);
        
        labels.forEach(label => {
            const labelText = label.textContent.replace(':', '').trim().toLowerCase().replace(/\s+/g, '');
            if (labelText) {
                // Look for the associated input
                const input = label.nextElementSibling;
                if (input && (input.tagName === 'INPUT' || input.tagName === 'SELECT' || input.tagName === 'TEXTAREA') && input.value) {
                    data[labelText] = input.value;
                    console.log(`Label association: ${labelText} = ${input.value}`);
                }
            }
        });

        return data;
    };    
        const formData = getAllFormData();
        console.log('Form data collected:', formData);

       const extractRequisitionID = () => {
        console.log('=== DEBUG: SEARCHING FOR REQUISITION ID ===');
        
        // Method 1: Check form data first
        let requisitionID = formData.requisitionID || formData.requisitionid || 
                        formData.reqid || formData.reqId || '';
        
        if (requisitionID && requisitionID !== 'Draft') {
            console.log('Found requisition ID in form data:', requisitionID);
            return requisitionID;
        }

        // Method 2: Look for ANY text content that contains REQ- pattern
        console.log('=== SEARCHING ALL TEXT CONTENT FOR REQ- PATTERN ===');
        const allElements = content.querySelectorAll('*');
        let foundIDs = [];
        
        allElements.forEach(element => {
            const text = element.textContent || '';
            if (text.includes('REQ-')) {
                console.log('Found REQ- in element:', element.tagName, element.className, text);
                
                // Extract REQ- followed by numbers
                const idMatches = text.match(/REQ-\d+/g);
                if (idMatches) {
                    idMatches.forEach(match => {
                        if (!foundIDs.includes(match)) {
                            foundIDs.push(match);
                            console.log('Found requisition ID:', match);
                        }
                    });
                }
                
                // Also look for any text that looks like a requisition ID
                const words = text.split(/\s+/);
                words.forEach(word => {
                    if (word.startsWith('REQ-') && word.length > 5) {
                        if (!foundIDs.includes(word)) {
                            foundIDs.push(word);
                            console.log('Found requisition ID in word:', word);
                        }
                    }
                });
            }
        });

        if (foundIDs.length > 0) {
            console.log('All found IDs:', foundIDs);
            return foundIDs[0]; // Return the first found ID
        }

        // Method 3: Look specifically in common display locations
        console.log('=== CHECKING SPECIFIC LOCATIONS ===');
        const specificSelectors = [
            '.view-requisition-date-and-id',
            '[class*="requisition"]',
            '[class*="req"]',
            'p', 'span', 'div', 'strong', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
        ];

        for (let selector of specificSelectors) {
            const elements = content.querySelectorAll(selector);
            console.log(`Checking ${elements.length} elements with selector: ${selector}`);
            
            for (let element of elements) {
                const text = element.textContent || '';
                if (text.includes('REQ-')) {
                    console.log(`Found in ${selector}:`, text);
                    const idMatch = text.match(/REQ-\d+/);
                    if (idMatch) {
                        console.log('Extracted ID:', idMatch[0]);
                        return idMatch[0];
                    }
                }
            }
        }

        // Method 4: Look for input fields that might contain the ID
        console.log('=== CHECKING INPUT FIELDS ===');
        const inputs = content.querySelectorAll('input, textarea');
        inputs.forEach(input => {
            const value = input.value || '';
            const placeholder = input.placeholder || '';
            const name = input.name || '';
            const id = input.id || '';
            
            console.log(`Input - name: ${name}, id: ${id}, value: ${value}, placeholder: ${placeholder}`);
            
            if (value.includes('REQ-')) {
                const idMatch = value.match(/REQ-\d+/);
                if (idMatch) {
                    console.log('Found in input value:', idMatch[0]);
                    return idMatch[0];
                }
            }
        });

        // Method 5: Get the inner HTML and search for REQ- pattern
        console.log('=== SEARCHING RAW HTML ===');
        const htmlContent = content.innerHTML;
        const htmlIdMatch = htmlContent.match(/REQ-\d+/);
        if (htmlIdMatch) {
            console.log('Found in raw HTML:', htmlIdMatch[0]);
            return htmlIdMatch[0];
        }

        console.log('=== COMPREHENSIVE SEARCH FAILED ===');
        console.log('Content HTML structure:', content.innerHTML.substring(0, 1000)); // First 1000 chars
        
        console.log('Could not find requisition ID, using default "Draft"');
        return 'Draft';
    };
            const requisitionID = extractRequisitionID();
            const requisitionDate = formData.requisitionDate || new Date().toLocaleDateString();
            const status = formData.status || 'Draft';
            const staffName = formData.staffName || formData.staffname || '';

            console.log('=== FINAL EXTRACTED VALUES ===');
            console.log('Requisition ID:', requisitionID);
            console.log('Requisition Date:', requisitionDate);
            console.log('Status:', status);
            console.log('Staff Name:', staffName);
            
        const printWindow = window.open('', '_blank', 'width=1000,height=800');
        
        // Show loading message in print window
        printWindow.document.write(`
            <html>
            <head>
                <title>Preparing Print...</title>
                <style>
                    body { 
                        font-family: Arial, sans-serif; 
                        display: flex; 
                        justify-content: center; 
                        align-items: center; 
                        height: 100vh; 
                        background: #f5f5f5;
                        margin: 0;
                    }
                    .loading {
                        text-align: center;
                        padding: 30px;
                        background: white;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                    }
                    .spinner {
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #3498db;
                        border-radius: 50%;
                        width: 50px;
                        height: 50px;
                        animation: spin 1s linear infinite;
                        margin: 0 auto 20px;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    .loading-text {
                        font-size: 16px;
                        color: #333;
                    }

                    /* ADD THIS STYLE FOR DISTRICT PAIRS IN PRINT */
                    .district-pair-item {
                        margin-bottom: 8px;
                        padding: 6px 0;
                        border-bottom: 1px solid #e0e0e0;
                        font-size: 10px;
                    }
                    
                    .district-pair-label {
                        font-weight: bold;
                        margin-right: 5px;
                    }
                    
                    .district-pair-value {
                        display: block;
                        margin-top: 2px;
                    }

                    
                </style>
            </head>
            <body>
                <div class="loading">
                    <div class="spinner"></div>
                    <div class="loading-text">Preparing document for printing...</div>
                </div>
            </body>
            </html>
        `);
        printWindow.document.close();

        // Use setTimeout to ensure the loading screen is displayed
        setTimeout(() => {
            // IMPROVED COST DRIVERS EXTRACTION
            const extractCostDrivers = () => {
                const costDrivers = [];
                console.log('Starting cost drivers extraction...');
                
                // Method 1: Try to find the cost drivers table
                const costDriverTable = content.querySelector('#cost-drivers-wrapper table');
                if (costDriverTable) {
                    const rows = costDriverTable.querySelectorAll('tbody tr');
                    console.log(`Found ${rows.length} cost driver rows`);
                    
                    rows.forEach((row, index) => {
                        const cells = row.querySelectorAll('td');
                        console.log(`Row ${index} has ${cells.length} cells`);
                        
                        if (cells.length >= 6) {
                            // Extract cost driver name - try multiple methods
                            let costDriver = '';
                            
                            // Method 1: Look for select element with selected option
                            const select = cells[0].querySelector('select');
                            if (select) {
                                costDriver = select.value || select.options[select.selectedIndex]?.text || '';
                            }
                            
                            // Method 2: Look for input element
                            if (!costDriver) {
                                const input = cells[0].querySelector('input');
                                if (input) {
                                    costDriver = input.value || '';
                                }
                            }
                            
                            // Method 3: Look for React Select component
                            if (!costDriver) {
                                const reactSelectValue = cells[0].querySelector('.react-select__single-value');
                                if (reactSelectValue) {
                                    costDriver = reactSelectValue.textContent || '';
                                }
                            }
                            
                            // Method 4: Look for any text content
                            if (!costDriver) {
                                costDriver = cells[0].textContent?.trim() || '';
                            }
                            
                            const justification = cells[1].querySelector('textarea')?.value || cells[1].textContent || '';
                            const quantity = cells[2].querySelector('input')?.value || cells[2].textContent || '0';
                            const unitPrice = cells[3].querySelector('input')?.value || cells[3].textContent || '0';
                            const total = cells[4].querySelector('input')?.value || cells[4].textContent || '0';
                            const supportDocuments = cells[5].querySelector('textarea')?.value || cells[5].textContent || '';
                            
                            console.log(`Cost driver ${index}:`, { costDriver, justification, quantity, unitPrice, total });
                            
                            if (costDriver || justification || quantity !== '0' || unitPrice !== '0') {
                                costDrivers.push({
                                    costDriver: costDriver.trim(),
                                    justification: justification.trim(),
                                    quantity: quantity.trim(),
                                    unitPrice: unitPrice.trim(),
                                    total: total.trim(),
                                    supportDocuments: supportDocuments.trim()
                                });
                            }
                        }
                    });
                }
                
                // Method 2: If no table found, try to find any cost driver inputs
                if (costDrivers.length === 0) {
                    const costDriverInputs = content.querySelectorAll('[class*="cost"], [class*="driver"]');
                    costDriverInputs.forEach(input => {
                        if (input.value) {
                            costDrivers.push({
                                costDriver: input.value,
                                justification: '',
                                quantity: '',
                                unitPrice: '',
                                total: '',
                                supportDocuments: ''
                            });
                        }
                    });
                }
                
                console.log('Final cost drivers:', costDrivers);
                return costDrivers;
            };

            const costDrivers = extractCostDrivers();



            const extractDistrictPairs = () => {
    const districtPairs = [];
    console.log('=== TARGETED DISTRICT EXTRACTION ===');
    
    // Find all field containers that contain district selects
    const fieldContainers = content.querySelectorAll('.field-container');
    
    fieldContainers.forEach((container, index) => {
        // Look for the district select specifically
        const districtSelect = container.querySelector('.custom-select-control');
        
        if (districtSelect) {
            // Get the district value from the single value element
            const singleValue = districtSelect.querySelector('.css-1dimb5e-singleValue');
            const district = singleValue?.textContent || '';
            
            // Skip if this is likely a cost driver (contains specific keywords)
            if (district.includes('FCI Staff') || district.includes('Perdiem') || 
                district.includes('DSA') || district.includes('Vehicle')) {
                console.log(`Skipping cost driver: ${district}`);
                return;
            }
            
            // Get the area program from the text input in the same container
            let areaProgram = '';
            const textInputs = container.querySelectorAll('input[type="text"]');
            
            textInputs.forEach(input => {
                // Check if this is the area program input by its placeholder or preceding label
                const prevLabel = input.previousElementSibling;
                if ((prevLabel && prevLabel.textContent.includes('Area Program')) ||
                    input.placeholder?.toLowerCase().includes('area program')) {
                    areaProgram = input.value || '';
                }
            });
            
            // If we found a valid district (not empty and not a cost driver), add the pair
            if (district && !district.includes('Select District')) {
                districtPairs.push({
                    district: district.trim(),
                    areaProgram: areaProgram.trim()
                });
                console.log(`Added district pair: ${district} - ${areaProgram}`);
            }
        }
    });
    
    console.log('Final district pairs:', districtPairs);
    return districtPairs;
};

const extractSignatureImage = () => {
    console.log('=== DEBUG SIGNATURE EXTRACTION ===');
    console.log('Content HTML:', content.innerHTML);
    
    // Look for all images to see what's available
    const allImages = content.querySelectorAll('img');
    console.log(`Found ${allImages.length} images total:`);
    allImages.forEach((img, index) => {
        console.log(`Image ${index}:`, img.outerHTML);
    });
    
    // Check localStorage
    const signatureFilePath = localStorage.getItem("signatureFilePath");
    console.log('Signature file path from localStorage:', signatureFilePath);
    
    // Try to construct URL
    if (signatureFilePath) {
        const baseUrl = process.env.REACT_APP_STATIC_BASE_URL || 'http://localhost:5259';
        const fullUrl = `${baseUrl}/${signatureFilePath}`;
        console.log('Constructed signature URL:', fullUrl);
        return fullUrl;
    }
    
    return null;
};
            const districtPairs = extractDistrictPairs();
            const signatureImageUrl = extractSignatureImage(); 
            

            printWindow.document.open();
            printWindow.document.write(`
                <html>
                <head>
                    <title>Requisition Form - ${requisitionID}</title>
                    <style>
                    @page {
                        margin: 0; /* Remove default page margins */
                        size: auto; /* Use default paper size */
                    }

                    /* Hide the browser's default header and footer */
                    @page :header {
                        display: none !important;
                    }

                    @page :footer {
                        display: none !important;
                    }
                        /* Reset and base styles */
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        
                        body {
                            font-family: 'Arial', sans-serif;
                            font-size: 12px;
                            line-height: 1.4;
                            color: #000;
                            padding: 20px 25px;
                            background: white;
                        }
                        
                        /* Header styles */
                        .print-header {
                            text-align: center;
                            margin-bottom: 2px;
                            padding-bottom: 2px;
                            border-bottom: 2px solid #333;
                        }
                        
                        .print-header h1 {
                            font-size: 22px;
                            margin-bottom: 2px;
                            color: #2c3e50;
                            text-transform: uppercase;
                            letter-spacing: 1px;
                        }
                        
                        .print-meta {
                            display: flex;
                            justify-content: space-between;
                            font-size: 12px;
                            margin-bottom: 2px;
                            flex-wrap: wrap;
                            gap: 15px;
                        }
                        
                        .meta-item {
                            display: flex;
                            flex-direction: column;
                        }
                        
                        .meta-label {
                            font-weight: bold;
                            color: #555;
                            margin-bottom: 0px;
                        }
                        
                        /* Three-column layout for basic info */
                        .info-columns {
                            display: grid;
                            grid-template-columns: repeat(3, 1fr);
                            gap: 20px;
                            margin-bottom: 3px;
                        }
                        
                        .info-column {
                            background: #f8f9fa;
                            padding: 18px;
                            border-radius: 6px;
                            border: 1px solid #e9ecef;
                            height: fit-content;
                        }
                        
                        .info-column h4 {
                            margin-bottom: 5px;
                            color: #495057;
                            border-bottom: 2px solid #007bff;
                            padding-bottom: 8px;
                            font-size: 14px;
                            text-transform: uppercase;
                            font-weight: bold;
                        }
                        
                        .form-field {
                            margin-bottom: 2px;
                        }
                        
                        .form-field label {
                            display: block;
                            font-weight: bold;
                            font-size: 11px;
                            margin-bottom: 4px;
                            color: #555;
                            text-transform: uppercase;
                        }
                        
                        .form-field .field-value {
                            padding: 8px 10px;
                            border: 1px solid #ddd;
                            border-radius: 4px;
                            background: white;
                            min-height: 35px;
                            display: flex;
                            align-items: center;
                            word-break: break-word;
                            font-size: 11px;
                        }
                        
                        .empty-field {
                            color: #999;
                            font-style: italic;
                        }
                        
                        /* Table styles */
                        .print-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 20px 0;
                            font-size: 10px;
                            page-break-inside: avoid;
                        }
                        
                        .print-table th {
                            background-color: #2c3e50;
                            color: black; /*white*/;
                            padding: 5px 6px;
                            text-align: left;
                            font-weight: bold;
                            border: 1px solid #444;
                            font-size: 11px;
                            text-transform: uppercase;
                        }
                        
                        .print-table td {
                            padding: 4px 6px;
                            border: 1px solid #ddd;
                            vertical-align: top;
                        }
                        
                        .print-table tfoot td {
                            background-color: #e9ecef;
                            font-weight: bold;
                            border-top: 2px solid #333;
                            font-size: 11px;
                        }
                        
                        /* Cost driver table */
                        .cost-driver-table {
                            font-size: 9px;
                        }
                        
                        .cost-driver-table td {
                            max-width: 180px;
                            overflow-wrap: break-word;
                        }
                        
                        .cost-driver-table .justification-cell {
                            max-width: 250px;
                        }
                        
                      
                        /* Signature section */
                        .signature-section {
                            margin-top: 30px;
                            padding-top: 20px;
                            border-top: 1px solid #333;
                            text-align: center;
                            width: 100%;
                        }

                        .signature-container {
                            display: inline-block;
                            text-align: center;
                            margin: 0 auto;
                            padding: 10px 20px;
                        }

                        .signed-by-label {
                            font-size: 11px;
                            margin-bottom: 8px;
                            color: #666;
                            text-transform: none !important;
                        }

                        .signature-image {
                            max-width: 120px !important;
                            max-height: 40px !important;
                            border-bottom: 1px solid #000;
                            margin: 0 auto 4px auto;
                            display: block;
                        }

                        .signature-line {
                            height: 1px;
                            border-bottom: 1px solid #000;
                            margin: 0 auto 4px auto;
                            width: 150px;
                        }

                        .user-full-name {
                            font-weight: bold;
                            margin-top: 3px;
                            font-size: 11px;
                            text-transform: none !important;
                        }
                      
                        /* Hide unnecessary elements for print */
                        .no-print,
                        button,
                        .buttons-container,
                        .navbar,
                        .sidebar,
                        footer,
                        .add-button,
                        .remove-button,
                        .round-button,
                        .checkbox-container,
                        .back-button,
                        .custom-select-control,
                        .react-select__control,
                        .fa-chevron-down,
                        .dropdown-wrapper::after,
                        .view-requisition-header,
                        .staff-activity-container,
                        .form-group h3 {
                            display: none !important;
                        }
                        
                        /* Remove all interactive elements and style display values */
                        input, select, textarea {
                            border: none !important;
                            background: transparent !important;
                            padding: 0 !important;
                            margin: 0 !important;
                            width: 100% !important;
                            box-shadow: none !important;
                            appearance: none;
                        }
                        
                        /* Style readonly inputs to look like normal text */
                        .read-only, .read-only-input {
                            border: none !important;
                            background: transparent !important;
                            padding: 0 !important;
                        }
                        
                        /* Page break control */
                        .page-break {
                            page-break-before: always;
                        }
                        
                        .avoid-break {
                            page-break-inside: avoid;
                        }
                        
                        /* Status badge */
                        .status-badge {
                            display: inline-block;
                            padding: 4px 12px;
                            background: #28a745;
                            color: white;
                            border-radius: 4px;
                            font-size: 11px;
                            font-weight: bold;
                            text-transform: uppercase;
                        }
                        
                        /* Section headers for remaining content */
                        .content-section {
                            margin: 30px 0;
                        }
                        
                        .content-section h3 {
                            background-color: #e9ecef;
                            padding: 12px 18px;
                            margin-bottom: 4px;
                            border-left: 5px solid #007bff;
                            font-size: 16px;
                            font-weight: bold;
                            color: #2c3e50;
                            text-transform: uppercase;
                        }
                    </style>
                </head>
                <body>
                    <div class="print-header">
                        <h1>REQUISITION FORM</h1>
                        <div class="print-meta">
                            
                            
                        </div>
                    </div>

                    <div class="info-columns">
                        <!-- Staff Information Column -->
                        <div class="info-column">
                            <h4>Staff Details</h4>
                            <div class="form-field">
                                <label>Staff Name:</label>
                                <div class="field-value">${formData.staffName || formData.staffname || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Staff Level:</label>
                                <div class="field-value">${formData.staffLevel || formData.stafflevel || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Supervisor Name:</label>
                                <div class="field-value">${formData.supervisorName || formData.supervisorname || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            
                        </div>
                        
                        <!-- Activity Information Column -->
                        <div class="info-column">
                            <h4>Activity Details</h4>
                            <div class="form-field">
                                <label>Activity Duration:</label>
                                <div class="form-field">
                                    <label>From:</label>
                                <div class="field-value">${formData.from || '<span class="empty-field">Not provided</span>'}</div>
                                </div>
                                <div class="form-field">
                                    <label>To:</label>
                                    <div class="field-value">${formData.to || '<span class="empty-field">Not provided</span>'}</div>
                                </div>
                            </div>
                            <div class="form-field">
                                <label>Activity Name:</label>
                                <div class="field-value">${formData.activityName || formData.activityname || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Activity Purpose:</label>
                                <div class="field-value">${formData.activityPurpose || formData.activitypurpose || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Target Client:</label>
                                <div class="field-value">${formData.targetClient || formData.targetclient || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Expected Impact:</label>
                                <div class="field-value">${formData.expectedImpact || formData.expectedimpact || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            
                            
                            <div class="form-field">
                                <label>Country:</label>
                                <div class="field-value">${formData.country || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            
                            <!-- DISTRICT & AREA PROGRAM PAIRS -->
                            <div class="form-field">
                                <label>District & Area Program:</label>
                                <div class="field-value" style="padding: 10px; background: #f8f9fa; border-radius: 4px;">
                                    ${districtPairs.length > 0 ? `
                                    <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                                        <thead>
                                            <tr>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${districtPairs.map((pair, index) => `
                                                <tr>
                                                    <td style="padding: 4px; border-bottom: 1px solid #eee;">${index + 1}</td>
                                                    <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.district || 'Not specified'}</td>
                                                    <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.areaProgram || 'Not specified'}</td>
                                                </tr>
                                            `).join('')}
                                        </tbody>
                                    </table>
                                ` : '<span class="empty-field">Not provided</span>'}

                                </div>
                            </div>
                            <div class="form-field">
                                <label>Hub Office:</label>
                                <div class="field-value">${formData.hubOffice || formData.huboffice || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                        </div>
                        
                        <!-- Project Information Column -->
                        <div class="info-column">
                            <h4>Project Details</h4>
                            <div class="form-field">
                                <label>Project Code:</label>
                                <div class="field-value">${formData.projectCode || formData.projectcode || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Project Name:</label>
                                <div class="field-value">${formData.projectName || formData.projectname || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Budget Line Code:</label>
                                <div class="field-value">${formData.budgetLineCode || formData.budgetlinecode || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            
                            <div class="form-field">
                                <label>Pay Mode:</label>
                                <div class="field-value">${formData.payMode || formData.paymode || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Bank Name:</label>
                                <div class="field-value">${formData.bankName || formData.bankname || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Branch:</label>
                                <div class="field-value">${formData.branch || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                            <div class="form-field">
                                <label>Account Number:</label>
                                <div class="field-value">${formData.accountNumber || formData.accountnumber || '<span class="empty-field">Not provided</span>'}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Cost Drivers Section -->
                     
                        <h4>Cost Drivers </h4>                
                        ${costDrivers.length > 0 ? `
                            <table class="print-table cost-driver-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Cost Driver</th>
                                        <th>Justification</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                        <th>Support Documents</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${costDrivers.map((driver, index) => `
                                        <tr>
                                            <td>${index + 1}</td>
                                            <td>${driver.costDriver || '<span class="empty-field">Not specified</span>'}</td>
                                            <td class="justification-cell">${driver.justification || '<span class="empty-field">Not provided</span>'}</td>
                                            <td>${driver.quantity || '0'}</td>
                                            <td>${driver.unitPrice || '0'}</td>
                                            <td>${driver.total || '0'}</td>
                                            <td>${driver.supportDocuments || '<span class="empty-field">Not specified</span>'}</td>
                                        </tr>
                                    `).join('')}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="5" style="text-align: right;"><strong>Overall Total:</strong></td>
                                        <td><strong>${costDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0).toLocaleString()}</strong></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        ` : '<p class="empty-field">No cost drivers specified</p>'}
                   

                   <!-- Signature Section -->
                <div class="signature-section">
                    <div class="signature-container">
                        <div class="signed-by-label">Signed by:</div>
                        ${signatureImageUrl ? `
                            <img src="${signatureImageUrl}" alt="Signature" class="signature-image" />
                        ` : `
                            <div class="signature-line"></div>
                        `}
                        <div class="user-full-name">${staffName}</div>
                        <div style="font-size: 10px; color: #666; margin-top: 2px;">${new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                    </div>
                </div>
                </div>

                </body>
                </html>
            `);
            
            printWindow.document.close();
            
            // Wait for content to render completely before printing
            setTimeout(() => {
                printWindow.focus();
                printWindow.print();
                
                // Close the window after printing
                setTimeout(() => {
                    printWindow.close();
                    setIsPreparingPrint(false);
                }, 1000);
                
            }, 2000);
            
        }, 1000);

    };

    return (
        <div>
            <button 
                className={`the-print-button ${isPreparingPrint ? 'printing' : ''}`} 
                onClick={handlePrint}
                disabled={isPreparingPrint}
                style={{
                    opacity: isPreparingPrint ? 0.7 : 1,
                    cursor: isPreparingPrint ? 'not-allowed' : 'pointer'
                }}
            >
                <i className="fas fa-print"></i> 
                {buttonLabel}
            </button>
        </div>
    );
};

export default PrintButton;